// ============================================================================
// 🎬 ANIMATIONS ESSENTIELLES - QUIZFOOT LEAGUE
// ============================================================================

// 1️⃣ CONFETTI - Célébration
export const createConfetti = () => {
  const colors = ['#ffd700', '#ffed4e', '#ffc700', '#ff6b6b', '#4ecdc4', '#45b7d1'];
  const confettiPieces = 50;

  for (let i = 0; i < confettiPieces; i++) {
    const confetti = document.createElement('div');
    const x = Math.random() * window.innerWidth;
    const color = colors[Math.floor(Math.random() * colors.length)];
    const size = Math.random() * 10 + 5;
    const duration = Math.random() * 3 + 2;
    const delay = Math.random() * 0.5;

    confetti.style.position = 'fixed';
    confetti.style.left = x + 'px';
    confetti.style.top = '-10px';
    confetti.style.width = size + 'px';
    confetti.style.height = size + 'px';
    confetti.style.backgroundColor = color;
    confetti.style.borderRadius = '50%';
    confetti.style.pointerEvents = 'none';
    confetti.style.zIndex = '9999';

    document.body.appendChild(confetti);

    const keyframes = `
      @keyframes confetti-fall-${i} {
        0% { transform: translateY(0) rotateZ(0deg); opacity: 1; }
        100% { transform: translateY(${window.innerHeight + 200}px) rotateZ(720deg); opacity: 0; }
      }
    `;

    const style = document.createElement('style');
    style.textContent = keyframes;
    document.head.appendChild(style);

    confetti.style.animation = `confetti-fall-${i} ${duration}s linear ${delay}s forwards`;
    setTimeout(() => confetti.remove(), (duration + delay) * 1000);
  }
};

// 2️⃣ LEVEL UP - Montée de niveau
export const animateLevelUp = (fromLevel, toLevel) => {
  const container = document.createElement('div');
  container.style.position = 'fixed';
  container.style.top = '50%';
  container.style.left = '50%';
  container.style.transform = 'translate(-50%, -50%)';
  container.style.zIndex = '9999';
  container.style.pointerEvents = 'none';

  container.innerHTML = `
    <div style="
      font-size: 80px;
      font-weight: 900;
      color: #FFB81C;
      text-shadow: 0 0 20px rgba(240, 180, 41, 0.8);
      text-transform: uppercase;
      letter-spacing: 4px;
      font-family: 'Rajdhani', sans-serif;
    ">
      LEVEL UP !
    </div>
    <div style="
      font-size: 48px;
      color: #4ecdc4;
      margin-top: 20px;
      text-align: center;
      font-weight: bold;
    ">
      ${fromLevel} → ${toLevel}
    </div>
  `;

  document.body.appendChild(container);

  const keyframes = `
    @keyframes levelup-popup {
      0% { transform: translate(-50%, -50%) scale(0) rotate(-45deg); opacity: 0; }
      50% { transform: translate(-50%, -60%) scale(1.2) rotate(0deg); opacity: 1; }
      100% { transform: translate(-50%, -150%) scale(1) rotate(0deg); opacity: 0; }
    }
  `;

  const style = document.createElement('style');
  style.textContent = keyframes;
  document.head.appendChild(style);

  container.style.animation = 'levelup-popup 2s ease-out forwards';
  createConfetti();

  setTimeout(() => container.remove(), 2000);
};

// 3️⃣ LOADING SPINNER - Chargement
export const createLoadingSpinner = (container) => {
  const spinner = document.createElement('div');
  spinner.style.width = '50px';
  spinner.style.height = '50px';
  spinner.style.border = '4px solid rgba(255, 255, 255, 0.3)';
  spinner.style.borderTop = '4px solid #FFB81C';
  spinner.style.borderRadius = '50%';
  spinner.style.margin = '0 auto';

  const keyframes = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  const style = document.createElement('style');
  style.textContent = keyframes;
  document.head.appendChild(style);

  spinner.style.animation = 'spin 1s linear infinite';
  container.appendChild(spinner);

  return { remove: () => spinner.remove() };
};

// 4️⃣ NOTIFICATION - Message toast
export const showNotification = (message, type = 'success', duration = 3000) => {
  const notification = document.createElement('div');
  notification.style.position = 'fixed';
  notification.style.top = '20px';
  notification.style.right = '20px';
  notification.style.padding = '16px 24px';
  notification.style.borderRadius = '8px';
  notification.style.fontSize = '16px';
  notification.style.fontWeight = 'bold';
  notification.style.zIndex = '10000';
  notification.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';

  if (type === 'success') {
    notification.style.backgroundColor = '##003DA5';
    notification.style.color = 'white';
    notification.textContent = '✅ ' + message;
  } else if (type === 'error') {
    notification.style.backgroundColor = '#ef4444';
    notification.style.color = 'white';
    notification.textContent = '❌ ' + message;
  } else {
    notification.style.backgroundColor = '#3b82f6';
    notification.style.color = 'white';
    notification.textContent = 'ℹ️ ' + message;
  }

  document.body.appendChild(notification);

  const keyframes = `
    @keyframes slideIn {
      from { transform: translateX(400px); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
    @keyframes slideOut {
      from { transform: translateX(0); opacity: 1; }
      to { transform: translateX(400px); opacity: 0; }
    }
  `;

  const style = document.createElement('style');
  style.textContent = keyframes;
  document.head.appendChild(style);

  notification.style.animation = 'slideIn 0.3s ease-out';

  setTimeout(() => {
    notification.style.animation = 'slideOut 0.3s ease-in forwards';
    setTimeout(() => notification.remove(), 300);
  }, duration);

  return notification;
};

// 5️⃣ SHAKE - Erreur/tremlement
export const shakeElement = (element, intensity = 10, duration = 500) => {
  return new Promise((resolve) => {
    const originalTransform = element.style.transform || '';
    const startTime = Date.now();

    const shake = () => {
      const elapsed = Date.now() - startTime;
      const progress = elapsed / duration;

      if (progress < 1) {
        const shakeAmount = intensity * Math.cos(progress * Math.PI * 4) * (1 - progress);
        element.style.transform = `${originalTransform} translateX(${shakeAmount}px)`;
        requestAnimationFrame(shake);
      } else {
        element.style.transform = originalTransform;
        resolve();
      }
    };

    shake();
  });
};

export default {
  createConfetti,
  animateLevelUp,
  createLoadingSpinner,
  showNotification,
  shakeElement,
};

